import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

const dsn = 'https://6a45239f27c14912919e0ac1b068a476@o173594.ingest.sentry.io/5870115';
if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.REACT_SENTRY_ENV || 'development',
	});
}

hydrate();
